// ---------------------------------------------- modules import
import React, { FunctionComponent } from "react";
import { Redirect } from "react-router-dom";

// ---------------------------------------------- the component
const Dashboard: FunctionComponent = () => <Redirect to="/dashboard" />;

export default Dashboard;
